import React from 'react'

import { Button } from 'semantic-ui-react'

import styles from './PrimaryButton.module.scss'


const PrimaryButton = (props) => {
    const { children, className } = props

    return (
        <Button {...props} className={`${styles.PrimaryButton}${className ? ` ${className}` : ''}`}>
            {children}
        </Button>
    )
}

export default PrimaryButton